import {defineComponent, onMounted, ref} from "vue"
import {useRoute} from "vue-router"
import {CourseServices} from '../../services/course/CourseServices'
import type { AxiosError, AxiosResponse } from "axios";

export default defineComponent({
    name: 'SubscriptionConfirmation',
    setup() {

        const route = useRoute()
        const message = ref('')

        const home = ref({
            to: '/',
            label: 'Home'
        })

        const breadcrumbItems = ref([
            {label: 'Subscription'}
        ])

        onMounted(async () => {

            const email = route.query.email as string
            const token = route.query.token as string

            const params = new URLSearchParams()
            params.append('email', email)
            params.append('token', token ?? "")

            if (route.path.includes('course/subscribe')) {
                await CourseServices.subscribe(params)
                    .then((response: AxiosResponse) => {
                        console.log("response: ", response)
                        message.value = response.data.message
                    }).catch((err: AxiosError) => {
                        message.value = err.response?.data.message
                    })
            } else if (route.path.includes('course/unsubscribe')) {
                await CourseServices.unsubscribe(params)
                    .then((response: AxiosResponse) => {
                        console.log("response: ", response)
                        message.value = response.data.message
                    }).catch((err: AxiosError) => {
                        message.value = err.response?.data.message
                    })
            } else {
                message.value = 'An error has occurred as the URL you provided is not valid'
            }

            console.log('FINAL > message.value: ', message.value)

        })

        return {
            home,
            message,
            breadcrumbItems,
        }
    }
})

